module.exports = __webpack_public_path__ + "img/unverified.f147fdd7.svg";